import {FullGameFetchHandler} from "../../../../../core/handlers/full-game.fetch-handler";

export class MatchEventsModuleFetchHandler extends FullGameFetchHandler {}
